import { FunctionComponent, PropsWithChildren } from 'react';

import { CSSInterpolation } from '@mui/material';
import Typography from '@mui/material/Typography';

import { globalTheme } from '../../../../../../../../shared/theme/theme';
import Box from '../../../../../../../shared/components/ui/Box';
import { CampaignDetailsColumnProps } from './models/campaign-details-column.props';

const CampaignDetailsColumn: FunctionComponent<CampaignDetailsColumnProps> = (
  props: PropsWithChildren<CampaignDetailsColumnProps>
): JSX.Element => {
  const typographyStyles: CSSInterpolation = {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '17px',
  };

  return (
    <Box
      sx={{
        maxWidth: '200px',
        width: '100%',
      }}
    >
      <Typography
        component="p"
        sx={{
          ...typographyStyles,
          color: globalTheme.palette.appGrey.darkGray,
          marginBottom: '2px',
        }}
      >
        {props.title}:
      </Typography>

      <Typography
        component="p"
        sx={{
          ...typographyStyles,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {props.content}
      </Typography>
    </Box>
  );
};

export default CampaignDetailsColumn;
